import { PROTECTED_ROUTES } from '@shared/utils';

function isLoggedInRequiredRoute(path: string): boolean {
  return PROTECTED_ROUTES.some(({ prefix, suffix, exceptions }) => {
    if (exceptions?.length && exceptions.includes(path)) {
      return false;
    }
    const matchesPrefix = prefix ? path.startsWith(prefix) : true;
    const matchesSuffix = suffix ? path.endsWith(suffix) : true;
    return matchesPrefix && matchesSuffix;
  });
}

export { isLoggedInRequiredRoute };
